import React from "react";
import { Layout } from '../../components/Layout';
import WillBeBackPage from '../WillBeBackPage'

function BuyAppleWatch9(){
    return(
        <Layout bgThemeVariant="light" iconColor="gray">
            <WillBeBackPage
                pageContent='Apple Watch Series 9 STORE'
            />
   
        </Layout>
    )
}

export default BuyAppleWatch9;